import z from 'zod';
import { createServerFn } from '@tanstack/react-start';
import { db } from '@/db';
import { User, user } from '@/db/schema';
import { and, eq, ne } from 'drizzle-orm';

export const checkUsernameSchema = z.object({
  username: z.string().min(3).max(50),
});

export const checkUsername = createServerFn({ method: 'POST' })
  .inputValidator(checkUsernameSchema)
  .handler(async (ctx) => {
    const { username } = ctx.data;

    const existing = await db
      .select()
      .from(user)
      .where(and(eq(user.username, username)))
      .execute();

    if (existing.length > 0) {
      return {
        success: false,
        field: 'username',
        message: 'Username is already taken',
      };
    }

    return { success: true, message: 'Username is available' };
  });
